<section class="dts tsx psx" *ngIf="product as p" [class.tsx-single]="!groups.length"
         [style]="colorVars"
         [style.--tsx-wallpaper]="wallpaper">
  <!-- a layer over the whole box from the page (the palettes page's expander draws its popover edge) -->
  <ng-content select="[tsxOverlay]"></ng-content>
  <!-- the old theme banner's two logo halves in the box's corners (owner 2026-10-15), in the theme's first colour -->
  <svg class="box-logo box-logo-left" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 210 297">
    <defs>
      <!-- the theme's first colour, a touch lighter towards the box's middle -->
      <linearGradient [id]="'psxLogoTopRight_' + p.key" x1="1" y1="0" x2="0" y2="1">
        <stop offset="0" style="stop-color: var(--plugin-primary, var(--theme-color))"/>
        <stop offset="1" style="stop-color: color-mix(in srgb, var(--plugin-primary, var(--theme-color)) 82%, #ffffff)"/>
      </linearGradient>
    </defs>
    <path [style.fill]="'url(#psxLogoTopRight_' + p.key + ')'" d="m 178.50387,213.25342 c 14.21454,-12.55147 17.57518,-39.48208 6.87786,-55.13809 v 0 c -8.67477,-16.8641 -33.95747,-26.73174 -51.76202,-20.2132 v 0 L 79.25799,83.536554 162.79062,8e-5 102.34432,0 18.32417,83.536554 103.15283,168.36917 c -6.52233,17.80465 3.34909,43.08736 20.21314,51.76217 v 0 c 6.24325,4.26283 14.27194,6.29676 22.47262,6.29676 v 0 c 12.368,0 25.11827,-4.62604 32.66528,-13.17468"/>
  </svg>
  <svg class="box-logo box-logo-right" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 210 297">
    <defs>
      <!-- the theme's first colour, a touch lighter towards the box's middle -->
      <linearGradient [id]="'psxLogoBottomLeft_' + p.key" x1="0" y1="1" x2="1" y2="0">
        <stop offset="0" style="stop-color: var(--plugin-primary, var(--theme-color))"/>
        <stop offset="1" style="stop-color: color-mix(in srgb, var(--plugin-primary, var(--theme-color)) 82%, #ffffff)"/>
      </linearGradient>
    </defs>
    <path [style.fill]="'url(#psxLogoBottomLeft_' + p.key + ')'" d="M 31.496131,83.498219 C 17.281586,96.049685 13.920954,122.9803 24.61827,138.63631 v 0 c 8.67477,16.8641 33.95747,26.73174 51.762024,20.2132 v 0 l 54.361716,54.36558 -83.532627,83.53647 60.446297,8e-5 84.02015,-83.53655 -84.82866,-84.83262 C 113.3695,110.57782 103.49808,85.295107 86.634028,76.620298 v 0 C 80.390777,72.357466 72.362085,70.323536 64.161412,70.323536 v 0 c -12.368001,0 -25.118271,4.626039 -32.665281,13.174683"/>
  </svg>
  <div class="dts-copy">
    <!-- the app on top, as the themes box names its platform; the theme's icon and the palette's name;
         its 24 named colors as a strip; then its page and its Get Now -->
    <span class="dts-eyebrow tsx-eyebrow">
      <img class="dts-eyebrow-logo" *ngIf="paletteApp?.logo" [src]="paletteApp?.logo" alt="" width="18" height="18"/>{{ paletteApp?.name }}
    </span>
    <ng-container *ngFor="let k of [ p.key ]">
      <h2 class="dts-title tsx-fade" [style.--tsx-chars]="title.length"><img class="dts-title-icon" [src]="p.logo" alt="" width="48" height="48"/>{{ title }}</h2>
    </ng-container>
    <p class="dts-lead tsx-tags">{{ palette?.colors?.length }} Named Colors · {{ active?.category }} · {{ p.appearance }}</p>
    <p class="dts-text psx-story">The {{ p.name }} theme distilled into {{ palette?.colors?.length }} named colors, {{ firstAndLast }}, ready for the apps you design in.</p>
    <!-- the palette itself: the palette posters' strip (theme-card), every color a chip that grows up out of
         the band under the pointer and shows its name -->
    <div class="psx-strip" role="img" [attr.aria-label]="title + ': ' + palette?.colors?.length + ' colors'">
      <!-- a click copies the colour's hex (owner 2026-10-12: a hand over the colours) -->
      <button type="button" class="psx-cell" *ngFor="let c of palette?.colors" [style.background-color]="c.hex"
              [attr.aria-label]="'Copy ' + c.name + ' ' + c.hex" (click)="copyHex( c.hex )">
        <span class="psx-cell-name">{{ c.name }}<span class="psx-cell-hex">{{ copiedHex === c.hex ? 'Copied' : c.hex }}</span></span>
      </button>
    </div>
    <div class="dts-actions">
      <a class="codigrate-button" [routerLink]="paletteUrl" [queryParams]="paletteQuery" (click)="discover()"><p>Discover More</p></a>
      <button type="button" class="codigrate-button" [disabled]="cartDisabled" [class.disabled]="cartDisabled" (click)="getNow()">
        <p>{{ comingSoon ? 'Coming Soon' : 'Add to cart' }}</p>
      </button>
      <!-- the price beside Add to cart, as the themes box shows it (owner 2026-10-15); none while it cannot
           be bought -->
      <span class="tsx-offer" *ngIf="appPrice && !cartDisabled">
        <span class="tsx-offer-amount">{{ appPrice }}</span>
        <span class="tsx-offer-note">{{ appPrice === 'Free' ? 'Open source' : 'One-time purchase' }}</span>
      </span>
    </div>
  </div>

  <div class="dts-show">
    <div class="dts-head">
      <h3 class="dts-headline"><span class="dts-accent">{{ title }}</span> in {{ appName }}</h3>
      <p class="dts-head-line tsx-head-line">{{ platformLine }}</p>
    </div>

    <div class="dts-stage">
      <div class="dts-scenes on" data-layout="one">
        <ng-container *ngFor="let src of [ screenshot?.src ]">
          <button type="button" class="dts-scene tsx-shot psx-shot" *ngIf="src" (click)="enlarge()"
                  [attr.aria-label]="'Enlarge: ' + title + ' in ' + appName">
            <img class="tsx-fade" [src]="src" [alt]="paletteApp?.screenshot?.description || title" decoding="async"/>
          </button>
        </ng-container>
      </div>
    </div>

    <!-- the apps the palette comes for, as logos; for one palette alone, centred in their own row under
         both sides, where the home has its palettes' dock (owner 2026-10-15) -->
    <ng-container *ngIf="groups.length" [ngTemplateOutlet]="appDock"></ng-container>
  </div>

  <div class="tsx-dock-row" *ngIf="!groups.length"><ng-container [ngTemplateOutlet]="appDock"></ng-container></div>

  <!-- every palette as its theme's icon (its name on hover), Nature, then Cities; none for one palette alone
       (the palettes page's expander) -->
  <div class="tsx-themes" *ngIf="groups.length">
    <span class="tsx-dock-label" aria-hidden="true">Palettes</span>
    <div class="tsx-tray" #tray role="group" aria-label="Palettes">
      <ng-container *ngFor="let g of groups; let first = first; trackBy: trackGroup">
        <span class="tsx-divider" *ngIf="!first" aria-hidden="true"></span>
        <div class="tsx-group" role="group" [attr.aria-label]="g.label + ' palettes'">
          <button type="button" class="tsx-poster" *ngFor="let t of g.items; trackBy: trackTheme"
                  [attr.data-key]="t.product.key"
                  [class.on]="t.product.key === p.key" [attr.aria-pressed]="t.product.key === p.key"
                  [attr.aria-label]="titleOf( t.product )" [title]="titleOf( t.product )"
                  [style.--poster-primary]="t.product.designTokens?.primaryColor"
                  (click)="pickPalette( t.product.key )">
            <img [src]="t.product.logo" alt="" width="36" height="36" loading="lazy" decoding="async" draggable="false"/>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</section>

<ng-template #appDock>
  <div class="tsx-platform-row">
    <span class="tsx-dock-label" aria-hidden="true">Apps</span>
    <div class="tsx-platforms" role="group" aria-label="Apps">
      <button type="button" class="tsx-platform" *ngFor="let pl of palette?.platforms; let i = index"
              [class.on]="i === platformIndex" [attr.aria-pressed]="i === platformIndex" [title]="pl.name" [attr.aria-label]="pl.name"
              (click)="pickApp( i )">
        <img [src]="pl.logo" alt="" width="22" height="22"/><span class="psx-app-name">{{ appShort( pl ) }}</span>
      </button>
    </div>
  </div>
</ng-template>

<!-- Lightbox: as the themes box's, outside the section -->
<div class="cp-lightbox" *ngIf="lightbox" role="dialog" aria-modal="true" [attr.aria-label]="lightbox.name" (click)="closeLightbox()">
  <figure class="cp-lightbox-inner" (click)="$event.stopPropagation()">
    <img [src]="lightbox.large" [alt]="lightbox.alt">
  </figure>
  <img class="td-lb-preload" [src]="shotAt( -1 ).large" alt="">
  <img class="td-lb-preload" [src]="shotAt( 1 ).large" alt="">
  <div class="cp-lightbox-caption-row" (click)="$event.stopPropagation()">
    <button class="cp-lb-seg cp-lb-nav" type="button" (click)="stepLightbox( -1, $event )" aria-label="Previous picture">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4.5 L7.5 12 L15 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
    </button>
    <span class="cp-lb-seg td-lb-label">
      <span class="cp-lb-name">
        <span class="cp-lb-name-sizer" *ngFor="let s of shots" aria-hidden="true">{{ s.name }}</span>
        <span class="cp-lb-name-cur">{{ lightbox.name }}</span>
      </span>
    </span>
    <button class="cp-lb-seg cp-lb-nav" type="button" (click)="stepLightbox( 1, $event )" aria-label="Next picture">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4.5 L16.5 12 L9 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
    </button>
    <button class="cp-lb-seg cp-lb-close" type="button" (click)="closeLightbox()" aria-label="Close">&times;</button>
  </div>
</div>
